export default "__VITE_ASSET__DRJup5Ln__"